// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/picker/index.css
// module id = 151
// module chunks = 32